module.exports = __webpack_public_path__ + "assets/los-angeles-sales-recruiting-agency-1.aadd5e5e.png";